import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Plus from '@images/svg/ui/plus.svg';

const MediaAddButton = ({ handleNewFiles }) => {
  const inputRef = useRef(null);
  const onFileChange = event => {
    const newFiles = [];
    for (let i = 0; i < event.target.files?.length; i++) {
      newFiles.push({
        file: event.target.files[i],
        preview: URL.createObjectURL(event.target.files[i])
      });
    }
    handleNewFiles(newFiles);
    // Empty input again
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  return (
    <div className='c-media-add-button'>
      <input
        ref={inputRef}
        type='file'
        accept='.jpg,.jpeg,.png'
        multiple
        id='imageinput'
        className='c-media-add-button__input'
        onChange={onFileChange}
      />
      <label htmlFor='imageinput' title='Bilder hinzufügen' className='c-media-add-button__button'>
        <Plus />
      </label>
    </div>
  );
};

MediaAddButton.propTypes = {
  handleNewFiles: PropTypes.func.isRequired
};

export default MediaAddButton;
